import { RootState } from 'store';
import styled from 'styled-components';
import AddIcon from 'assets/svgs/AddIcon';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { DatePicker, message, Skeleton } from 'antd';
import UserListingSection from './UserListingSection';
import { getQueryFormId } from 'modules/EmailBrowser/utils';
import SelectSearch from 'modules/Analytics/Shared/SelectSearch';
import ConfirmDialog from 'modules/Common/Components/ConfirmDialog';
import SelectWithIcon from 'modules/Campaigns/Shared/SelectWithIcon';
import GlobalCustomButton from 'modules/Common/Components/GlobalCustomButton';
import { ISortConfigFormAudience, ISortOrderFormAudience } from '../interfaces';
import {
  formAudienceSetFilterCategorySelection,
  formAudienceResetSearchAction,
  formAudienceResetSearchContacts,
  formAudienceSetSearchAction,
  getFormAudienceAction,
  formAudienceCreateNewListAction,
  formAudienceResetContacts,
  formAudienceResetContactsListOnly,
} from '../actions';

const FormSubmissionWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column;
  @media all and (max-width: 1439px) {
    .global-custom-btn-style {
      padding: 0px 8px !important;
      height: 34px !important;
    }
    .submission-add-list > div > div {
      min-height: 34px !important;
      width: 190px !important;
      border-radius: 6px !important;
    }
  }
  .css-c3py3x-singleValue {
    font-family: 'Roboto' !important;
    font-weight: 500;
    line-height: 20px;
  }
  .css-1uxsi1k-menu {
    min-width: 250px !important;
    min-height: 150px !important;
  }
`;
const FormSubmissionHeader = styled.div`
  min-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px 0 12px 0;
`;
const Title = styled.div`
  color: #67696a;
  font-family: 'Roboto';
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 34px;
  @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
    font-size: 20px !important;
  }
  @media all and (max-width: 1024px) and (-webkit-device-pixel-ratio: 1.25) {
    font-size: 16px !important;
  }
`;
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  .submission-add-list {
    .css-vqtttq-ValueContainer {
      padding: 0;
    }
    > div {
      > div {
        min-height: 38px;
        width: 220px;
        border-radius: 8px;
      }
    }
  }
`;
const SearchBar = styled.div`
  max-width: 595px;
  width: 595px;
  .search-input {
    height: 44px;
    margin-top: 0 !important;
    &::-webkit-input-placeholder {
      color: #c1c1c1 !important;
      line-height: 16px !important;
      font-weight: 400 !important;
      font-size: 16px !important;
      font-style: italic !important;
      font-family: 'Roboto' !important;
      letter-spacing: -0.36px !important;
      @media all and (max-width: 1439px) {
        font-size: 13px !important;
      }
    }
    &:-moz-placeholder {
      font-family: 'robotothin_italic';
      color: #c1c1c1;
    }
    &::-moz-placeholder {
      font-family: 'robotothin_italic';
      color: #c1c1c1;
    }
    &:-ms-input-placeholder {
      font-family: 'robotothin_italic';
      color: #c1c1c1;
    }
  }
  span.clear-search {
    margin-top: 0 !important;
    display: flex !important;
  }
  @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
    .refresh-search svg {
      width: 16px !important;
      height: 16px !important;
    }
  }
  @media all and (max-width: 1280px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
    width: 200px;
    .search-bar {
      max-width: 200px;
      width: 200px !important;
    }
  }
  @media all and (max-width: 1280px) and (-webkit-device-pixel-ratio: 1) {
    width: 200px;
    .search-bar {
      max-width: 200px;
      width: 200px !important;
    }
    .search-input {
      font-size: 13px !important;
      &::-webkit-input-placeholder {
        font-size: 13px !important;
      }
      &:-moz-placeholder {
        font-size: 13px !important;
      }
      &::-moz-placeholder {
        font-size: 13px !important;
      }
      &:-ms-input-placeholder {
        font-size: 13px !important;
      }
    }
  }
  @media all and (max-width: 1280px) {
    width: 180px;
    .search-bar {
      max-width: 180px;
      width: 180px !important;
      height: 34px !important;
    }
    .search-input {
      font-size: 13px !important;
    }
  }
`;

const DialogWrapper = styled.div`
  .setting-delete-dialog {
    width: 326px !important;
    .message {
      font-family: 'Roboto' !important;
      font-weight: 700 !important;
      line-height: 26px !important;
      font-size: 20px !important;
    }
  }
  .message-footer {
    margin: 24px 20px 10px 20px;
  }
  .message-footer a {
    font-family: 'Roboto' !important;
    line-height: 20px !important;
    font-size: 20px !important;
    font-weight: 700 !important;
  }
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  .back-overlay {
    position: fixed;
    background: grey;
    opacity: 0.2;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    z-index: 16;
  }
`;

const dates = [
  { label: 'All time', value: 'all' },
  { label: '1 QTR', value: 'qtr' },
  { label: 'Month', value: 'month' },
  { label: 'Week', value: 'week' },
  { label: 'Day', value: 'day' },
  { label: 'Custom', value: 'custom' },
];

const SORT_ORDER_DEFAULT = {
  full_name: null,
  company_name: null,
  personality_name: null,
  origin_domain: null,
  created_on: null,
};

const SORT_ORDER_INITIAL = {
  full_name: null,
  company_name: null,
  personality_name: null,
  origin_domain: null,
  created_on: 'descend',
};

const FormSubmissionSection: React.FC = () => {
  // Redux states
  const {
    searchTerm,
    page,
    searchedPage,
    totalContacts,
    totalSearchedContacts,
    contacts,
    searchedContacts,
    loading,
    searchedLoading,
    filter: formAudienceFilter,
    // Flag becomes False when a single submission gets mapped to a contact;
    // Usecase : Prevent user from creating a list when no contact is mapped to a submission
    zeroContactMapping,
  } = useSelector((state: RootState) => state.formsAudience);

  // Local States
  const [prevFilterCategory, setPrevFilterCategory] = useState<string>('all'); //State for previously applied filter category
  const [prevCustomDates, setPrevCustomDates] = useState({ start_date: '', end_date: '' });
  const [sortingApplied, setSortingApplied] = useState<boolean>(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [sortOrder, setSortOrder] = useState<ISortOrderFormAudience>(SORT_ORDER_INITIAL); // State for updating sorting order of table columns header icons
  const [sortConfig, setSortConfig] = useState<ISortConfigFormAudience>({
    sortBy: 'created_on',
    sortType: 'DESC',
  });
  const [prevSortOrder, setPrevSortOrder] = useState<ISortOrderFormAudience>(SORT_ORDER_INITIAL);

  // Local Variables
  const history = useHistory();
  const formId = getQueryFormId();
  const totalFormContacts = searchTerm ? totalSearchedContacts : totalContacts;
  const formPage = searchTerm ? searchedPage : page;
  const currentFilterCategory = formAudienceFilter.selectedCategory.value;
  const filterChanged =
    prevFilterCategory !== currentFilterCategory ||
    prevCustomDates.start_date !== formAudienceFilter.startDate ||
    prevCustomDates.end_date !== formAudienceFilter.endDate;
  const confirmationDialog = {
    cancel: 'No',
    confirm: 'Yes',
    title: 'Are you sure you want to create a list?',
    className: 'confirm-dialog-content-contact',
    onConfirm: () => {
      // based on design ready we need to redirect to new list
      handleCreateNewList();
    },
    onCancel: () => {
      setShowConfirmationDialog(false);
    },
  };

  // Updating state of sorting order for updating sort icon on table header
  const updateSortingOrders = (property: keyof ISortOrderFormAudience) => {
    if (totalFormContacts === 0) {
      setSortOrder(SORT_ORDER_DEFAULT);
    } else {
      setSortOrder((prevSortOrder) => ({
        ...SORT_ORDER_DEFAULT,
        [property]: prevSortOrder[property] === 'ascend' ? 'descend' : 'ascend',
      }));
    }
  };

  //  Update the sort type (ascending or descending) and sort by(name,company,submitted)
  const updateSortingConfig = (sortContactBy: string, sortContactType: string) => {
    setSortConfig((prevConfig) => ({
      ...prevConfig,
      sortBy: sortContactBy,
      sortType: sortContactType,
    }));
  };

  const handleSortClick = (currentSortOrder: keyof ISortOrderFormAudience, sortContactBy: string, sortContactType: string) => {
    updateSortingOrders(currentSortOrder);
    updateSortingConfig(sortContactBy.toLowerCase(), sortContactType);
  };

  const getParams = (searchedTerm: string, page: number, formId: number, resetOffset?: boolean) => {
    const limit = 20;
    const offset = resetOffset ? 0 : limit * page;
    const searchTerm = searchedTerm;

    return {
      limit,
      offset,
      formId,
      sortBy: sortConfig.sortBy,
      searchTerm,
      sortType: sortConfig.sortType,
      startDate: formAudienceFilter.startDate,
      endDate: formAudienceFilter.endDate,
    };
  };

  const handleClearSearch = () => {
    formAudienceResetSearchAction();
    formAudienceResetSearchContacts();
  };

  const handleSearchSubmission = (s_term: string) => {
    if (s_term.trim() !== searchTerm) {
      if (s_term) formAudienceResetSearchContacts();
      formAudienceSetSearchAction(s_term);
    }
  };

  const handleCreateNewList = () => {
    formAudienceCreateNewListAction(getParams(searchTerm, 0, parseInt(formId))).then((res: any) => {
      history.push(`/audiences/view/?list_id=${res.listId}&form_id=${formId}`);
      message.success({
        content: `List has been created successfully`,
      });
    });
  };

  const fetchContacts = (resetOffset: boolean) => {
    getFormAudienceAction(getParams(searchTerm, formPage, parseInt(formId), resetOffset));
  };

  const loadMore = () => {
    if (formPage !== 0) getFormAudienceAction(getParams(searchTerm, formPage, parseInt(formId)));
  };

  useEffect(() => {
    if (sortOrder !== SORT_ORDER_INITIAL && sortOrder !== prevSortOrder) {
      formAudienceResetContactsListOnly();
      setSortingApplied(true);
    } else {
      setSortingApplied(false);
      if (searchTerm || filterChanged) {
        formAudienceResetSearchContacts();
      }
      if (filterChanged) {
        formAudienceResetContacts();
      }
    }

    if (searchTerm || totalContacts === 0 || filterChanged || sortOrder !== SORT_ORDER_INITIAL) {
      fetchContacts(true);
    }

    setPrevFilterCategory(currentFilterCategory);
    setPrevSortOrder(sortOrder);
    if (currentFilterCategory === 'custom') {
      setPrevCustomDates({ start_date: formAudienceFilter.startDate, end_date: formAudienceFilter.endDate });
    }
  }, [searchTerm, currentFilterCategory, sortOrder, formAudienceFilter.startDate, formAudienceFilter.endDate]);

  return (
    <>
      {showConfirmationDialog && (
        <DialogWrapper>
          <div className="back-overlay" />
          <ConfirmDialog
            className="setting-delete-dialog"
            cancel={confirmationDialog.cancel}
            confirm={confirmationDialog.confirm}
            onConfirm={confirmationDialog.onConfirm}
            onCancel={confirmationDialog.onCancel}
            title={confirmationDialog.title}
            titleQuestion={null}
          />
        </DialogWrapper>
      )}

      <FormSubmissionWrapper>
        {/* <ButtonWrapper>
          <GlobalAntButton
            maxWidth=""
            btnText={'Form Submission'}
            disabled={false}
            onClick={() => {}}
            border={'1px solid rgb(218, 218, 218)'}
            padding={''}
            bgColor={'rgb(222, 246, 230)'}
            color={'#1EC252'}
            customIcon={''}
            borderRadius={'8px'}
            fontSize={'16px'}
            boxShadow={''}
            icon={''}
            buttonType={'type'}
            btnType={'default'}
            loading={false}
            width={''}
          />
          <GlobalAntButton
            maxWidth=""
            btnText={'Analytics'}
            disabled={false}
            onClick={() => {}}
            border={'1px solid #DADADA;'}
            padding={''}
            bgColor={'#fff'}
            color={'#7E7E7E'}
            customIcon={''}
            borderRadius={'8px'}
            fontSize={'16px'}
            boxShadow={''}
            icon={''}
            buttonType={'type'}
            btnType={'default'}
            loading={false}
            width={''}
          />
        </ButtonWrapper> */}
        <FormSubmissionHeader>
          <Title>
            Submissions{' '}
            {(loading || searchedLoading) && !sortingApplied && page === 0 && searchedPage === 0 ? (
              <span style={{}}>
                {' '}
                <Skeleton.Button style={{ width: '50px', height: '25px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
              </span>
            ) : (
              <span>({totalFormContacts})</span>
            )}
          </Title>
          <InputWrapper>
            <SearchBar>
              <SelectSearch
                placeholder={'Search for contacts'}
                onSearchInput={() => {}}
                onClearSearch={handleClearSearch}
                onSubmit={handleSearchSubmission}
                disabled={false}
                isSearchIcon={false}
              />
              {/* <GlobalSearchBar
                placeholderProps={'Search for contacts'}
                handleSearchProps={handleSearchSubmission}
                clearSearchProps={handleClearSearch}
              /> */}
            </SearchBar>
            <SelectWithIcon
              id="date"
              defaultValue={{ value: 'Select Action', label: 'Select Action' }}
              options={dates}
              onChange={formAudienceSetFilterCategorySelection}
              value={formAudienceFilter.selectedCategory}
              className="submission-add-list"
              menuWidth={170}
              customDatePicker={<DatePicker bordered={false} />}
              isSmartSource
              disabled={totalFormContacts === 0 && prevFilterCategory === 'all'}
            />
            <GlobalCustomButton
              btnText={'Create new List'}
              disabled={totalFormContacts === 0 || zeroContactMapping}
              onClick={() => setShowConfirmationDialog(true)}
              border={'none'}
              padding={''}
              bgColor={'#1EC252'}
              color={'#fff'}
              customIcon={<AddIcon />}
              borderRadius={'6px'}
              fontSize={'16px'}
              boxShadow={''}
            />
          </InputWrapper>
        </FormSubmissionHeader>
        <UserListingSection
          handleSortClick={handleSortClick}
          sortOrder={sortOrder}
          loadMore={loadMore}
          searchTerm={searchTerm}
          loading={searchTerm ? searchedLoading : loading}
          activeSearchFilter={searchTerm !== '' || prevFilterCategory !== 'all'}
          contacts={searchTerm ? searchedContacts : contacts}
        />
      </FormSubmissionWrapper>
    </>
  );
};

export default FormSubmissionSection;
